// extracted by mini-css-extract-plugin
export default {"wavyButton":"styles_wavyButton__wGtEV","glowing":"styles_glowing__jytxp"};